import React, { useEffect } from "react";
import SVG_CloseIcon from "../../../assets/images/svgs/close-dark.svg?react";
import { useDispatch, useSelector } from "react-redux";
import { requestLockedBonus } from "../../../store/LockedBonus/lockedBonus.thunks";
import moment from "moment";

const LockedBonus = ({ open, onClose }) => {
  const auth = useSelector((state) => state?.auth);
  const bonusData = useSelector((state) => state?.lockedBonus?.lockedBonus);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      if (auth) {
        dispatch(
          requestLockedBonus({
            limit: 10,
            page: 1,
          })
        );
      }
    }
  }, [auth, open]);

  const filteredBonus = bonusData?.filter(
    (item) => item?.status_str !== "COMPLETED" && !item?.is_expired
  );

  if (!open) return null;

  return (
    <div className="z-[1000] fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-bg_Quaternary w-[95%] max-w-[550px] max-h-[80vh] p-2 rounded-md overflow-y-auto shadow-lg popUpOpenAnimation">
        {/* Close Button */}
        <div
          className="absolute top-3 right-3 cursor-pointer transition-all duration-200 hover:scale-110"
          onClick={onClose}
        >
          <SVG_CloseIcon />
        </div>

        {/* Title */}
        <div className="text-base font-lato font-semibold text-text_Ternary mb-4">
          Locked Bonus
        </div>

        {/* Bonus Progress List */}
        <div className="flex flex-col gap-3">
          {filteredBonus?.length > 0 ? (
            filteredBonus?.map((item, index) => {
              const progressPercent =
                (item?.used_rolling_amount * 100) / item?.total_rolling_amount;
              return (
                <div
                  key={index}
                  className="flex flex-col gap-1 p-3 border  rounded-md  bg-bg_Ternary8"
                >
                  <span className="text-sm mb-1 font-semibold">
                    {item?.bonus_type?.replaceAll("_", " ")}
                  </span>

                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-text_Primary text-sm">
                      Total Rolling :- {item?.used_rolling_amount}
                    </span>
                    <span className="text-sm text-text_Primary font-semibold">
                      {item.total_rolling_amount}
                    </span>
                  </div>

                  <div className="w-full bg-red-100 border rounded-full h-2 overflow-hidden">
                    <div
                      className={`h-2 transition-all duration-300 bg-green-500`}
                      style={{ width: `${progressPercent}%` }}
                    />
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-text_Primary text-sm mr-1">
                      <p>
                        Locked/Unlocked Bonus:-{" "}
                        {(
                          item?.total_locked_bonus_amount -
                          item?.unlocked_bonus_amount
                        )?.toFixed(2)}
                        /{item?.unlocked_bonus_amount?.toFixed(2)}
                      </p>
                    </span>
                    <span className="font-semibold text-text_Primary text-sm">
                      {`Expiry :- ${moment(item?.expire_at).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}`}
                    </span>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center">No Locked Bonus Found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LockedBonus;
